import { findIndex, find, propEq, pipe, keys, length } from 'ramda';

export const findItemIndex = (propName = 'id') => id => findIndex(propEq(propName, id));

export const findItem = (propName = 'id') => id => find(propEq(propName, id));

export const findItemIndexById = findItemIndex();

export const findItemById = findItem();

export const getKeysCount = pipe(keys, length);

export const shuffleArray = arr => {
  // eslint-disable-next-line no-plusplus
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    // eslint-disable-next-line no-param-reassign
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};
